// extracted by mini-css-extract-plugin
module.exports = {"featureImage":"GJtPPA","featureImageSmall":"_2CDsdm","featureImageMedium":"_2qC8w6","featureImageLarge":"_1JDLie","featureImageFullWidth":"_3YZCZv","caption":"_27tpXT"};